<template>
  <div class="main-header">
    <div class="main-header-logo">
      <div class="main-header-logo-con">
        <div class="main-header-logo-img">
          <img style="width: 100%;height: 100%;" src="../../assets/logo.png" alt="">
        </div>
        <div class="main-header-logo-title">
         <div style='letter-spacing:4px;font-weight: bold;'>资产运营管理平台</div>
          <div style='font-size: 13px;margin-top: 3px;letter-spacing:4px;'>中国铁建</div>
        </div>
      </div>
    </div>
    <div class="main-header-navbar flexlr">
      <div></div>
      <div class="navbar-custom-menu flexl">
          <div class="navbar-custom-menu-item flexl" :class="selectCustomNavType === 'user'?'active':''" @click.stop="selectCustomMenuFun('user')">
            <div class="img">
              <img style="width: 100%;height: 100%;border-radius: 50%;" src='@/assets/d_avatar.png' alt=''>
            </div>
            <div class="title" style='font-size: 14px;'>{{loginUserInfo.userName}}</div>
            <div class="select-body" v-show="selectCustomNavType === 'user'">
              <div style="width:280px;">
                <div style="height: 175px;padding: 10px;text-align: center;box-sizing: border-box;background-color: var(--zl-body-bg-color);">
                  <div style="width:90px;height: 90px;border-radius: 50%;overflow: hidden;margin: auto;border: 3px solid;border-color: rgba(255, 255, 255, 0.2);">
                    <img style="width: 100%;height: 100%;border-radius: 50%;" src='@/assets/d_avatar.png' alt=''>
                  </div>
                  <div style="color: rgba(255, 255, 255, 0.8);font-size: 17px;margin-top: 10px;"> {{loginUserInfo.userName}} </div>
                  <div style="color: rgba(255, 255, 255, 0.8);margin-top: 5px;font-size: 12px;"> {{loginUserInfo.loginTime}} </div>
                </div>
                <div class="flexlr select-body-footer" >
                  <div class="btn btn-primary flexl">
                    <div style="font-size: 18px;margin-top: 0px">
                      <i class="iconfont zmr_icon_i icon-wode"></i>
                    </div>
                    <div style="display: inline-block">个人资料</div>
                  </div>
                  <div class="btn btn-danger flexl" @click="loginOut">
                    <div style="font-size: 18px;margin-top: 1px">
                      <i class="iconfont zmr_icon_i icon-tuichudenglu"></i>
                    </div>
                    <div style="display: inline-block">退出登录</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-custom-menu-item flexl">
            <div style="margin-left: 0;font-size: 22px;position: relative;color: #333333">
              <i class="iconfont zmr_icon_i icon-xiaoxi"></i>
              <div class="red_msg_num">20</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {ref,watch} from 'vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import {getCache,clearAll} from "../../common/js/cache";

const router = useRouter();
const store = useStore();
const selectNavId = ref(store.state.activeMenuId);
const selectCustomNavType = ref('');
const loginUserInfo = ref(getCache('userInfo'));


watch(()=>store.state.activeMenuId,(newData,oldData)=>{
  if(newData !== oldData){
    selectNavId.value = newData;
  }
})

//右侧自定义菜单选择
const selectCustomMenuFun = (type) => {
  if(selectCustomNavType.value === type){
    selectCustomNavType.value = '';
  }else{
    selectCustomNavType.value = type;
  }
}

//退出登录
const loginOut = ()=>{
  clearAll();
  router.push({
    path:'/login'
  })
}

</script>
<style scoped lang="less">
.main-header {
  height: 60px;
  width: 100%;
  display: flex;
  background-image: url("../../assets/images/u2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .main-header-logo {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    transition: width 0.3s ease-in-out;
    background: transparent;
    width: max-content;
    font-size: 18px;
    font-weight: 300;
    overflow: hidden;
    color: white;
    height: 100%;
    padding: 0 var(--zl-menu-padding);
    box-sizing: border-box;
    white-space: nowrap;
    position: relative;
    cursor: pointer;

    .main-header-logo-con {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;

      .main-header-logo-img {
        width: 50px;
        overflow: hidden;
        margin-right: 10px;
      }
      .main-header-logo-title {
        flex: 1;
      }
    }

    .main-header-name-logo-img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      left: 7px;
      top: 7px;
    }
  }

  .main-header-logo-collapse {
    width: var(--zl-menu-collapse-width);
  }

  .main-header-navbar {
    background: transparent;
    flex: 1;

    .sidebar-toggle {
      height: 50px;
      width: 45px;
      text-align: center;
      font-size: 16px;
      color: white;
      border-left: 1px solid rgba(0, 0, 0, 0.05);
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .sidebar-toggle:hover {
      background-color: var(--zl-header-nav-active-color);
    }

    .active {
    }

    .nav-tabs {
      height: 50px;
      flex: 1;

      .nav-tabs_item {
        height: 100%;
        font-size: 15px;
        color: white;
        padding: 0 15px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        cursor: pointer;

        .nav_icon {
          width: 18px;
          height: 18px;
          font-size: 15px;
          margin-right: 3px;
        }

        .nav_icon_close {
          width: 16px;
          height: 16px;
          font-size: 14px;
          margin-left: 8px;
        }
      }

      .nav-tabs_item:hover {
        background-color: var(--zl-header-nav-active-color);
      }
    }

    .navbar-custom-menu {
      margin-left: 15px;
      box-sizing: border-box;

      .navbar-custom-menu-item {
        cursor: pointer;
        padding: 0 15px 0 0;
        height: 50px;
        position: relative;
        background: transparent;

        .img {
          width: 25px;
          height: 25px;
          margin-right: 5px;
        }

        .el-icon-d {
          margin-left: 5px;
          font-size: 15px;
          height: 15px;
        }

        .select-body {
          position: absolute;
          z-index: 222;
          right: 0;
          top: 51px;
          min-width: 160px;
          min-height: 100px;
          background: white;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
          background-clip: padding-box;
          border-bottom-left-radius: 3px;
          border-bottom-right-radius: 3px;
          color: #444444;

          .select-body-footer {
            padding: 10px;
            background-color: #f9f9f9;

            .btn {
              margin-bottom: 0;
              font-weight: normal;
              vertical-align: middle;
              cursor: pointer;
              border: 1px solid transparent;
              white-space: nowrap;
              padding: 6px 12px;
              font-size: 13px;
              border-radius: 3px;
            }

            .btn-primary {
              color: #fff;
              background-color: #444c69
            }

            .btn-danger {
              color: white;
              background-color: #f75444;
            }
          }
        }
      }
    }
  }
}
.red_msg_num{
  background-color:red;
  width:18px;
  height:18px;
  line-height: 18px;
  color:white;
  border-radius:50%;
  font-size:12px;
  text-align: center;
  position: absolute;
  top: -5px;
  right: -7px;
}
</style>
